// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .opening-hours-row[data-v-45140cc1] {\n  padding: 0.35rem 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n[dir] .opening-hours-row[data-v-45140cc1]:last-child {\n  border-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
